import { IPageTabNavLink } from "../interfaces-and-types";

export const interProiderTransfersNavLinks: IPageTabNavLink[] = [
  {
    name: "Prov-Transfers",
    route: "",
  },
];
